export default "<i [ngClass]=\"rating_class\"></i>";